export default __webpack_public_path__ + "static/media/App_Store.a08465ef.svg";